import "./scss/product-status-badge.scss";

const STATUS_MAP = {
  approved: {
    text: "Опубликован",
    className: "approved"
  },
  cancel: {
    text: "Отклонён",
    className: "cancel"
  },
  check: {
    text: "На проверке",
    className: "check"
  }
};

export default function ProductStatusBadge({ status }) {
  const normalized = status?.toLowerCase();
  const config = STATUS_MAP[normalized];

  if (!config) return null;

  return (
    <div className={`product-status-badge ${config.className}`}>
      {config.text}
    </div>
  );
}